import { useTranslation } from 'next-i18next';
import { VFC } from 'react';
import styles from './LatestNFTs.module.scss';
import NoNFTS from './NoCreations';
import { convertImgixURL } from '@/utils/imgixUtils';
import { convertFileNameToLowResolution } from '@/utils/convertFileName';

type Props = {
  //link: string;
  creations: any;
  isCreator: boolean;
};
type NFTS = {
  imageURL: string;
  key: string;
};
const defaultImageUrl =
  '/images/marketplacePageItems/defaultImageForLatestNFT.png';
const LatestNFTs: VFC<Props> = ({
  //link,
  creations,
  isCreator,
}) => {
  const { t } = useTranslation();
  const highestIndex = Math.min(creations.length, 3);
  let threeCreationsUrls: NFTS[] = [];
  if (isCreator) {
    for (let i = 0; i < highestIndex; i++) {
      const isoStr = new Date().toISOString(); //to generate random key foreach mapped element
      threeCreationsUrls.push({
        imageURL: creations[i].ImageUrl,
        key: isoStr.concat(creations[i].ImageUrl),
      });
    }
  } else {
    for (let i = 0; i < highestIndex; i++) {
      const isoStr = new Date().toISOString(); //to generate random key foreach mapped element
      threeCreationsUrls.push({
        imageURL: creations[i].AniftyToken.ImageUrl,
        key: creations[i].AniftyToken.ImageUrl.concat(isoStr),
      });
    }
  }
  return (
    <div className={styles.creationMediaContainer}>
      {threeCreationsUrls?.map((item, index) => {
        const isMp4: boolean = item.imageURL.includes('.mp4');
        if (!isMp4) {
          return (
            <img
              src={convertImgixURL(item.imageURL, { w: 200, auto: 'compress' })}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = defaultImageUrl;
              }}
              className={styles.creationMedia}
              key={item.key + index}
            ></img>
          );
        } else {
          return (
            <video
              autoPlay
              muted
              loop
              playsInline
              src={convertFileNameToLowResolution(item.imageURL)}
              className={styles.creationMedia}
              key={item.key}
            ></video>
          );
        }
      })}
      {threeCreationsUrls && threeCreationsUrls?.length == 0 && (
        <NoNFTS isCreator={isCreator} />
      )}
    </div>
  );
};

export default LatestNFTs;
